import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import NotificationsListPage from '../components/NotificationsListPage'
import {
  actionCreators,
  INotificationsListState,
  selectError,
  selectIsLoading,
  selectItemChangedIndex,
  selectItems,
  selectTotalItems,
  selectUnseenOnly,
} from '../modules/notificationsList'

export default withRouter(
  connect(
    createStructuredSelector<ApplicationState, INotificationsListState>({
      error: selectError(),
      isLoading: selectIsLoading(),
      itemChangedIndex: selectItemChangedIndex(),
      items: selectItems(),
      totalItems: selectTotalItems(),
      unseenOnly: selectUnseenOnly(),
    }),
    actionCreators,
  )(NotificationsListPage),
)
